import { BlockLoopCustomOption } from './block-loop-custom-option.model';
import { BlockQuotaModel } from './block-quota.interface';
import { BlockType } from './block-type.enum';
import { SurveyElementModel } from './survey-element.model';
import { LoopAllocationSettings, LoopSourceMedia } from './survey-loop.interface';

export class BlockModel extends SurveyElementModel {
  type: BlockType;
  /** Highest source index ever assigned to custom options or media on this block; never reduced on deletion. */
  lastSourceIndex?: number;
  sourceQId: string;
  groupedQuestionIds: string[];
  randomizedInd: boolean;
  groupedBlockIds: string[];
  isSubBlock: boolean;
  quotas: BlockQuotaModel[];
  evenDistributionInd: boolean;
  evenDistributionQuantity: number;
  sourceType: number;
  sourceOptions: BlockLoopCustomOption[];
  sourceOptionsRandomizedInd: boolean;
  allocation?: LoopAllocationSettings;
  sourceMedia?: LoopSourceMedia[];
  stimulusQuestionIds?: string[];
}
